<template>
  <v-card>
    <v-card-text class="text-xs-center headline primary--text">
      Editando a cobrança
      <v-tooltip bottom>
        <v-btn
          absolute
          right
          @click="tempCobranca.ativo = !tempCobranca.ativo"
          outline
          round
          slot="activator"
          :color="tempCobranca.ativo ? 'green darken-2' : 'red darken-2'"
        >
          <template v-if="tempCobranca.ativo">ATIVA</template>
          <template v-else>CANCELADA</template>
        </v-btn>
        <template v-if="tempCobranca.ativo">
          Clique para cancelar
        </template>
        <template v-else>
          Clique para tornar ativa
        </template>
      </v-tooltip>
    </v-card-text>
    <v-container flex grid-list-lg>
      <v-layout row wrap>
        <v-flex xs5>
          <v-text-field outline label="Valor (R$)" v-if="rendering" v-money="money" hide-details v-model="valor"></v-text-field>
        </v-flex>
        <v-flex xs7>
          <v-select
            outline
            placeholder="Combustível"
            single-line
            clearable
            :items="combustiveis"
            hide-details
            v-model="combustivel"
          >
            <template v-slot:selection="item">
              <v-list-tile-avatar>
                <svg-filler
                  :path="item.item.icone ? require(`@/assets/combs/${item.item.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                  width="50px"
                  height="50px"
                  :fill="item.item.color"
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  v-text="item.item.nome"
                  class="font-weight-medium"
                  :style="{color: item.item.color}"
                ></v-list-tile-title>
              </v-list-tile-content>
            </template>
            <template v-slot:item="item">
              <v-list-tile-avatar>
                <svg-filler
                  :path="item.item.icone ? require(`@/assets/combs/${item.item.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                  width="50px"
                  height="50px"
                  :fill="item.item.color"
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  v-text="item.item.nome"
                  class="font-weight-medium"
                  :style="{color: item.item.color}"
                ></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>
        <v-flex xs12>
          <v-textarea outline label="Detalhes da cobrança" v-model="tempCobranca.descricao" hide-details></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-btn @click="fecharTela()" flat color="grey darken-2">
        VOLTAR
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="atualizarDados()" flat color="green">
        SALVAR
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  props: ['cobranca'],
  data () {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      tempCobranca: {},
      valor: null,
      combustivel: null,
      rendering: true
    }
  },
  directives: { money: VMoney },
  mounted () {
    if (this.cobranca) {
      this.carregarDados()
    }
  },
  computed: {
    combustiveis () {
      return this.$store.getters.combustiveis
    }
  },
  watch: {
    cobranca (val) {
      if (val) {
        this.carregarDados()
      }
    }
  },
  methods: {
    fecharTela () {
      this.$emit('fechar')
    },
    carregarDados () {
      this.tempCobranca = { ...this.cobranca }
      this.valor = this.cobranca.valor
      this.rendering = false
      this.$nextTick(() => {
        this.rendering = true
      })
      this.combustiveis.forEach(comb => {
        if (comb.id_combustivel === this.cobranca.combustivel) {
          this.combustivel = comb
        }
      })
    },
    atualizarDados () {
      this.tempCobranca.valor = this.valor.split(' ')[1]
      this.tempCobranca.combustivel = this.combustivel ? this.combustivel.id_combustivel : null
      this.$store.dispatch('atualizarCobranca', {
        id: this.tempCobranca.id,
        data: { ...this.tempCobranca }
      }).then(() => {
        this.fecharTela()
      }).catch(() => {
        this.fecharTela()
      })
    }
  }
}
</script>
